import { Injectable } from '@angular/core';
import { UserSignIn } from './user.model';

const TOKEN_KEY = 'auth-token';
const REFRESHTOKEN_KEY = 'auth-refreshtoken';
const USER_KEY = 'auth-user';
const FACET_KEY = 'selected-facet-type-id';

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {
  public logout(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESHTOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(FACET_KEY);
  }

  public saveToken(token: string): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  public saveRefreshToken(token: string): void {
    localStorage.removeItem(REFRESHTOKEN_KEY);
    localStorage.setItem(REFRESHTOKEN_KEY, token);
  }

  public getRefreshToken(): string | null {
    return localStorage.getItem(REFRESHTOKEN_KEY);
  }

  public saveUser(user: UserSignIn): void {
    localStorage.removeItem(USER_KEY);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): UserSignIn | null {
    const user = localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }

    return null;
  }

  public saveFacetKey(key: number | null): void {
    const user = this.getUser();
    if (!user || !key) return;
    localStorage.setItem(
      FACET_KEY,
      JSON.stringify({
        ...JSON.parse(localStorage.getItem(FACET_KEY) ?? '{}'),
        [user.id]: key,
      }),
    );
  }

  public getFacetKey(): number | null {
    const key = localStorage.getItem(FACET_KEY);
    const user = this.getUser();
    if (!key || !user) return null;
    const keys = JSON.parse(key);
    return keys[user.id] ?? null;
  }
}
